import { reactToCwp } from '../../../common/react-utils'
import Welcome from './Welcome'

export default reactToCwp(Welcome)
